export const getError = state => state.supportModal.get('error')
export const getIsSubmitting = state => state.supportModal.get('isSubmitting')
